const CombinedProvider = ({ components = [], children, ...rest }) =>
  // eslint-disable-next-line react/jsx-props-no-spreading
  components.reduceRight(
    (acc, Provider) => <Provider {...rest}>{acc}</Provider>,
    children
  );
export default CombinedProvider;
